/**
 * Jurisdiction regulatory reference data (from API, not user PII).
 */
/** Requirement slugs that imply age or ID verification is needed. */
export const AGE_VERIFICATION_REQUIREMENT_SLUGS = [
    'age_verification',
    'highly_effective_age_assurance',
    'appropriate_age_assurance',
    'reliable_age_and_identity_verification',
    'age_assurance',
];
const AGE_VERIFICATION_REQUIREMENT_SLUG_SET = new Set(AGE_VERIFICATION_REQUIREMENT_SLUGS);
/** Returns true when a requirement slug triggers age/ID verification enforcement. */
export function requirementImpliesAgeVerification(requirement) {
    return AGE_VERIFICATION_REQUIREMENT_SLUG_SET.has(requirement);
}
//# sourceMappingURL=jurisdiction-types.js.map